import { useSelector, TypedUseSelectorHook } from 'react-redux';
import { AppState } from './reducers';

export const useTypedSelector: TypedUseSelectorHook<AppState> = useSelector;
